import $ from 'jquery';
import common from './common';

import smileyService from '../../Services/smiley';

const SMILEY_ELEMENT_SELECTOR = ':not(pre):not(code):not(.smilies)';

export default function (options) {
    let { container } = options;
    common(options);

    $(SMILEY_ELEMENT_SELECTOR, container).each((n, element) => {
        smileyService.smilize(element);
    });
}
